export const API_EXTERNAL_ENDPOINT = 'cottages-page'

export const API_INTERNAL_ENDPOINT = 'strapi/cottages-page'
